@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
                     [passportId]="passportId"></app-field-label>
    <div class="ps-3 border-start"
         role="group"
         [attr.aria-label]="attribute.translation.label | translate">
      @for (subAttribute of subAttributes; track subAttribute.valuePath) {
        <div class="pt-1">
          @if (isUrlAttribute(subAttribute)) {
            <app-document-input
              [attribute]="subAttribute"
              [passportId]="passportId"
              [fullValuePath]="fullValuePath + '.' + subAttribute.valuePath"
              [saveFunction]="subFieldSave"
              [passData]="getSubData(subAttribute.valuePath)"
            />
          } @else {
            <app-text-input
              [attribute]="subAttribute"
              [passportId]="passportId"
              [fullValuePath]="fullValuePath + '.' + subAttribute.valuePath"
              [saveFunction]="subFieldSave"
              [passData]="getSubData(subAttribute.valuePath)"
            />
          }
        </div>
      }
    </div>
  </div>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
